import { render, staticRenderFns } from "./role-management-icon.vue?vue&type=template&id=04036a53"
import script from "./role-management-icon.vue?vue&type=script&lang=js"
export * from "./role-management-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports